import React, { useState, useEffect, Fragment } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Button, Modal, Form, ListGroup, Badge, Spinner, Toast, Col, Row, InputGroup, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
    AddSubTask, GetsubTask, GetAccions, GetDocuments, CreateTemplate,
    UpdateTemplate, GetTemplate, ClearTemplate, GetWorkFlow, GetUsersCharge,
    GetUsersLegal
} from '../../Redux/TareasV2Ducks'
import { useForm } from 'react-hook-form'
import Select from 'react-select'
import { json } from 'react-router-dom'
import Cookies from 'universal-cookie'
import * as Icon from 'react-bootstrap-icons'
import './styles.css'

import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import paginationFactory from 'react-bootstrap-table2-paginator'


// Función para ayudar a reordenar la lista o mover un ítem entre listas
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source)
    const destClone = destination ? Array.from(destination) : []
    const [removed] = sourceClone.splice(droppableSource.index, 1)

    // Actualiza el campo 'sel' basado en la lista de destino
    const updatedItem = {
        ...removed,
        seleccionada: droppableDestination.droppableId === 'Seleccionadas',
    };

    if (droppableSource.droppableId === droppableDestination.droppableId) {
        sourceClone.splice(droppableDestination.index, 0, removed)
        return { [droppableSource.droppableId]: sourceClone }
    } else {
        // Asegúrate de usar updatedItem, el cual tiene el campo 'sel' actualizado
        destClone.splice(droppableDestination.index, 0, updatedItem)
        return {
            [droppableSource.droppableId]: sourceClone,
            [droppableDestination.droppableId]: destClone,
        };
    }
}

const NomenclaturasB = ({ nomenclaturasDisponibles, taskTemplateId, dateChange, onclickWorkflowCreado, servicios, taskWorkflowId, idGrupo, idServicio, setShowModal, offService, causa }) => {
    const cookies = new Cookies()

    const dispatch = useDispatch()
    const { register, handleSubmit } = useForm() //comentar
    const { register: registerC, handleSubmit: handleSubmitC, reset: resetC } = useForm() //accion

    //modalAddTask
    const [show, setShow] = useState(false)
    const [showTask, setShowTask] = useState(false)
    const [showDescriptionTask, setShowDescriptionTask] = useState(false)
    const [showAcctionTask, setShowAcctionTask] = useState(false)
    const [showDeleteAction, setShowDeleteAction] = useState({ showTarea: null, index: null, true: false })
    const [showToast, setShowToast] = useState(false)
    const [showSpinner, setShowSpinner] = useState(false)
    const [showUSerList, setShowUserList] = useState(false)
    const [UserSelect, setUserSelect] = useState(null)

    const [messageToast, setMessageToast] = useState("")


    const [seleccionAction, setSeleccionAction] = useState("")
    const [aproved, setAproved] = useState(false)
    const [searchNomenclature, setSearchNomenclature] = useState("")
    const [searchNomenclatureS, setsearchNomenclatureS] = useState("")
    const [searchTask, setSearchTask] = useState("")
    const [searchTaskS, setSearchTaskS] = useState("")

    const [cosmosId, setCosmosId] = useState(taskWorkflowId)


    const handleClose = () => setShow(false)
    const handleCloseTask = () => setShowTask(false)
    const handleCloseDescriptionTask = () => setShowDescriptionTask(false)
    const handleCloseAcctionTask = () => setShowAcctionTask(false)
    const handleCloseUserListTask = () => {
        setShowUserList(false)
        setUserSelect(null)
    }

    const handleShow = () => setShow(true);

    const [nomenclaturas, setNomenclaturas] = useState({ Disponibles: [], Seleccionadas: [] });
    const [subTareas, setSubTareas] = useState({ Disponibles: [], Seleccionadas: [] });

    const [showNomenclatura, setShowNomenclatura] = useState({})
    const [showTarea, setShowTarea] = useState({})
    const [showAcction, setShowAcction] = useState({})

    const [DragDisabled, setDragDisabled] = useState(true)

    // PARA CONFIGURAR LAS ACCIONES
    const [documentos, setDocumentos] = useState([])
    const [selectDocumento, setSelectDocumento] = useState([])
    const [nomenclaturaAccion, setNomenclaturaAccion] = useState({})
    const [servicioAccion, setServicioAccion] = useState({})

    const [nomenclaturasAcciones, setNomenclaturasAcciones] = useState([])
    const [tareaAccion, setTareaAccion] = useState({})
    const [tareasAcciones, setTareasAcciones] = useState([])
    const [UsuariosTareas, setUsuariosTareas] = useState([])

    const newSubTask = useSelector((store) => store.tareasV2.newSubTask)
    const template = useSelector((store) => store.tareasV2.template)
    const templateCreado = useSelector((store) => store.tareasV2.templateCreado)

    const subTasks = useSelector((store) => store.tareasV2.subTasks)
    const listaAcciones = useSelector((store) => store.tareasV2.listaAcciones)
    const documents = useSelector((store) => store.tareasV2.documents)
    const usersCharge = useSelector((store) => store.tareasV2.usersCharge)
    const usersLegal = useSelector((store) => store.tareasV2.usersLegal)

    const columns = [{
        dataField: 'username',
        text: 'Usuario',
        filter: textFilter(),
        events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
                setUserSelect(row)
            }
        }
    }, {
        dataField: 'tribunal',
        text: 'Tribunal',
        filter: textFilter()
    }, {
        dataField: 'branchOffice',
        text: 'Sucursal',
        filter: textFilter()
    }, {
        dataField: 'charge',
        text: 'Cargo',
        filter: textFilter()
    }];

    useEffect(() => {
        dispatch(GetsubTask())
        dispatch(GetAccions())
        dispatch(GetDocuments())
        dispatch(GetUsersCharge())
    }, [])

    useEffect(() => {
        if (usersCharge.data?.length > 0) {
            dispatch(GetUsersLegal())
        }
    }, [usersCharge])

    useEffect(() => {
        var userPrioridad
        if (usersLegal.data?.length > 0) {
            const _causa = { sucursal: 1, tribunal: "", grupo: 12, servicio: 3 }
            if (usersCharge.data?.length > 0) {
                const datosConNombres = usersCharge.data.map(dato => {
                    const usuarioCorrespondiente = usersLegal.data.find(usuario => usuario.id == dato.userId);
                    return {
                        id: dato.id,
                        tribunal: dato.tribunal ? dato.tribunal.name : "",
                        branchOffice: dato.branchOffice ? dato.branchOffice.name : "",
                        charge: dato.charge ? dato.charge.name : "",
                        username: usuarioCorrespondiente ? usuarioCorrespondiente.nombre : null, // Maneja el caso donde no se encuentra el usuario
                    };
                }).filter(dato => dato.username !== null)
                setUsuariosTareas(datosConNombres)
            }
            /*


            /*usersCharge [
            {
                "id": 1,
                "userId": 39,
                "tribunal": {
                    "id": 160,
                    "name": "1º Juzgado Civil de Santiago"
                },
                "charge": {
                    "id": 3,
                    "name": "Abogado Asistente EJS"
                },
                "branchOffice": {
                    "id": 1,
                    "name": "ARICA"
                }
            },...]
            */
        }
        //causa
    }, [usersLegal])


    useEffect(() => {
        setDocumentos(documents.list.map((item) => {
            return { value: item.id, label: item.nombre }
        }))
    }, [documents])

    useEffect(() => {
        setDocumentos(documents.list.map((item) => {
            return { value: item.id, label: item.nombre }
        }))
    }, [showTarea])

    useEffect(() => {
        setNomenclaturas(prevState => ({
            ...prevState,
            Disponibles: nomenclaturasDisponibles.map((item) => { return { id: "nomenclatura-" + item.id, content: item.nomenclatura, Descripcion: '', subTareas: [] } })
        }))
    }, [nomenclaturasDisponibles, dateChange])


    useEffect(() => {
        if (offService == false) return

        // Obtén los IDs de los elementos de nomenclaturas Seleccionadas
        const nomenclaturasSeleccionadas = new Set(nomenclaturas.Seleccionadas.map(t => t.id));

        // Filtra nomenclaturas Disponibles para excluir elementos cuyos IDs estén en nomenclaturas Seleccionadas
        const nomenclaturasDisponibles = nomenclaturas.Disponibles.filter(t => !nomenclaturasSeleccionadas.has(t.id));

        // Actualiza el estado con la nueva versión de listOne
        setNomenclaturas(prevState => ({
            ...prevState,
            Disponibles: nomenclaturasDisponibles,
            // Asume que deseas mantener listTwo como está, si no, ajusta según sea necesario
            Seleccionadas: nomenclaturas.Seleccionadas
        }));

        setNomenclaturasAcciones(nomenclaturas.Seleccionadas.map((item) => {
            return { value: item.id, label: item.content }
        }))


    }, [nomenclaturas.Seleccionadas])


    useEffect(() => {
        if (subTasks.listSubTask.length < 1) return;

        const disponibles = subTasks.listSubTask.map((item) => { return { id: "task-" + item.id, Name: item.name, Descripcion: item.description, acciones: [] } });

        // Obtén los IDs de los elementos de subTareas Seleccionadas
        const subTareasSeleccionadas = new Set(subTareas.Seleccionadas.map(t => t.id));

        // Filtra subTareas Disponibles para excluir elementos cuyos IDs estén en subTareas Seleccionadas
        const subTareasDisponibles = disponibles.filter(t => !subTareasSeleccionadas.has(t.id));

        // Actualiza el estado con la nueva versión de listOne
        setSubTareas(prevState => ({
            ...prevState,
            Disponibles: subTareasDisponibles,
            // Asume que deseas mantener listTwo como está, si no, ajusta según sea necesario
            Seleccionadas: subTareas.Seleccionadas
        }));

        setTareasAcciones(subTasks.listSubTask.map((item) => {
            return { value: item.id, label: item.name }
        }))
    }, [subTasks])

    useEffect(() => {
        if (newSubTask.status == 2) {
            // Función para actualizar el estado
            setSubTareas(subTareas => ({
                ...subTareas, // Copiamos todo el estado anterior
                Disponibles: [
                    ...subTareas.Disponibles, // Copiamos todos los objetos existentes en B
                    { id: 'task-' + newSubTask.task.id, idNomenClatura: '', Name: newSubTask.task.name, Descripcion: newSubTask.task.description, status: false, acciones: [] }, // Agregamos el nuevo objeto al final de B
                ]
            }))
        }
    }, [newSubTask])

    useEffect(() => {
        if (offService == false) {
            setNomenclaturas({ Disponibles: [], Seleccionadas: [] })
            return;
        }
    }, [offService])

    // VA A BUSCAR EL TEMPLATE
    useEffect(() => {
        if (offService == false) return;


        setShowSpinner(true)
        setNomenclaturas(prevState => ({
            ...prevState,
            Seleccionadas: []
        }));
        if (taskTemplateId == null && taskWorkflowId == null) {
            setShowSpinner(false)
            return
        }

        if (taskWorkflowId != null) {
            dispatch(GetWorkFlow({ id: taskWorkflowId, GroupId: idGrupo }))
        } else {
            dispatch(GetTemplate({ id: taskTemplateId }))
        }
    }, [taskTemplateId, dateChange])


    useEffect(() => {
        setTimeout(() => {
            if (taskTemplateId == null && taskWorkflowId == null) {
                setNomenclaturas(prevState => ({
                    ...prevState,
                    Seleccionadas: []
                }));
            }
        }, 100);
    }, [dateChange])


    //PASA EL TEMPLATE A LA VISTA
    useEffect(() => {

        if (taskTemplateId == null && taskWorkflowId == null) return
        //if (template.data.listOfTasks == null) return
        setNomenclaturas(prevState => ({
            ...prevState,
            Seleccionadas: []
        }));


        setTimeout(() => {
            if (offService == false) return;

            let templateseleccion = []
            if (template.data.listOfTasks)
                templateseleccion = template.data.listOfTasks.map((item) => {
                    const subT = item.subTareas.map((st) => {
                        st.id = `task-${st.idSubTask}`
                        st.Name = st.name
                        st.Descripcion = st.descripcion

                        st.acciones = st.acciones.map((acc) => {
                            const ac = listaAcciones.list.find(lacc => lacc.id == acc.id);
                            if (ac != null)
                                acc.action = ac
                            return acc
                        })
                        return st
                    })
                    return { id: "nomenclatura-" + item.nomencltureId, content: item.nomenclatura, Descripcion: item.descripcion, subTareas: subT }
                })

            setNomenclaturas(prevState => ({
                ...prevState,
                Seleccionadas: templateseleccion
            }));

            setTimeout(() => { setShowSpinner(false) }, 550)

        }, 500);
    }, [template])
    
    const onDragEnd = (result) => {
        const { source, destination } = result
        if (!destination) return
        var updatedState = move(nomenclaturas[source.droppableId], nomenclaturas[destination.droppableId], source, destination)
        setNomenclaturas((prevState) => ({ ...prevState, ...updatedState, }))
    };

    const onDragEndSubTask = (result) => {
        const { source, destination } = result
        if (!destination) return
        const updatedState = move(subTareas[source.droppableId], subTareas[destination.droppableId], source, destination)
        setSubTareas((prevState) => ({ ...prevState, ...updatedState, }))
    }

    const onAddSubTask = (data) => {
        dispatch(AddSubTask(data))
        handleClose()
    }

    const onAddDescriptionTask = (data) => {
        setShowToast(true)
        setMessageToast("Tarea actualizada, ahora puede cerrar")
    }

    const onAddAcctionTask = (data) => {
        data.nomenclatura = nomenclaturaAccion.id == undefined ? 0 : nomenclaturaAccion.id.replace('nomenclatura-', '')
        data.servicio = servicioAccion.value == undefined ? 0 : servicioAccion.value
        data.subTarea = tareaAccion.id == undefined ? 0 : tareaAccion.id.replace('task-', '')
        data.documento = selectDocumento.length == 0 ? 0 : selectDocumento
        data.aprobar = aproved
        data.action = seleccionAction
        data.id = seleccionAction.id


        setSelectDocumento([])
        setServicioAccion({})
        setAproved(false)


        setShowTarea(prevTask => ({
            ...prevTask,
            acciones: [...prevTask.acciones, data]
        }));

        setSubTareas(prevTask => {
            // Encuentra el índice del objeto en Sel que coincide con el ID
            const indice = prevTask.Seleccionadas.findIndex(objeto => objeto.id === showTarea.id);
            // Si no se encuentra el objeto, simplemente devuelve el estado anterior
            if (indice === -1) return prevTask;
            // Crea una copia de Sel y actualiza el objeto encontrado
            const SelActualizado = [...prevTask.Seleccionadas];
            //var acciones = SelActualizado[indice].acciones
            //acciones = acciones.push(data)
            SelActualizado[indice] = { ...SelActualizado[indice], acciones: [...SelActualizado[indice].acciones, data] };
            // Devuelve el nuevo estado con Sel actualizado
            return { ...prevTask, Seleccionadas: SelActualizado };
        });
        handleCloseAcctionTask()

        setShowToast(true)
        setMessageToast("accion agregada a la tarea")
    }

    const handleSaveUserTask = () => {

        setShowTarea(prevTask => ({
            ...prevTask,
            idUserCharge: UserSelect.id,
            UserSelect: UserSelect
        }));

        setSubTareas(prevTask => {
            // Encuentra el índice del objeto en Sel que coincide con el ID
            const indice = prevTask.Seleccionadas.findIndex(objeto => objeto.id === showTarea.id);
            // Si no se encuentra el objeto, simplemente devuelve el estado anterior
            if (indice === -1) return prevTask;
            // Crea una copia de Sel y actualiza el objeto encontrado
            const SelActualizado = [...prevTask.Seleccionadas];
            //var acciones = SelActualizado[indice].acciones
            //acciones = acciones.push(data)
            SelActualizado[indice] = { ...SelActualizado[indice], idUserCharge: UserSelect.id, UserSelect: UserSelect };
            // Devuelve el nuevo estado con Sel actualizado
            return { ...prevTask, Seleccionadas: SelActualizado };
        });

    }

    const handleSaveDescriptionTask = () => {
        setSubTareas(prevTask => {
            // Encuentra el índice del objeto en Sel que coincide con el ID
            const indice = prevTask.Seleccionadas.findIndex(objeto => objeto.id === showTarea.id)
            // Si no se encuentra el objeto, simplemente devuelve el estado anterior
            if (indice === -1) return prevTask
            // Crea una copia de Sel y actualiza el objeto encontrado
            const SelActualizado = [...prevTask.Seleccionadas]
            //var acciones = SelActualizado[indice].acciones
            //acciones = acciones.push(data)
            if (UserSelect == null)
                SelActualizado[indice] = { ...SelActualizado[indice], name: showTarea.Name, Descripcion: showTarea.Descripcion }
            else
                SelActualizado[indice] = { ...SelActualizado[indice], name: showTarea.Name, Descripcion: showTarea.Descripcion, idUserCharge: UserSelect.id, UserSelect: UserSelect }
            // Devuelve el nuevo estado con Sel actualizado
            return { ...prevTask, Seleccionadas: SelActualizado }
        });
    }

    const onShowSubTaskNom = (item, droppableId) => {
        item.subTareas.forEach(subTarea => {
            const correspondencia = subTasks.listSubTask.find(item => item.id === subTarea.idSubTask);
            if (correspondencia) {
                subTarea.name = correspondencia.name;
                subTarea.Name = correspondencia.name; // Actualiza ambos campos por consistencia
            }
        });

        if (droppableId !== 'Seleccionadas') return;
        //NOMENCLATURA SELECCIONADA
        setShowNomenclatura(item)
        //IR A BUSCAR TODAS LAS TAREAS QUE TIENE 
        dispatch(GetsubTask())
        // Obtén los IDs de los elementos de subTareas Seleccionadas
        const subTareasSeleccionadas = new Set(item.subTareas.map(t => t.id));
        // Filtra subTareas Disponibles para excluir elementos cuyos IDs estén en subTareas Seleccionadas
        const subTareasDisponibles = subTareas.Disponibles.filter(t => !subTareasSeleccionadas.has(t.id));
        // Actualiza el estado con la nueva versión de listOne
        setSubTareas(prevState => ({
            ...prevState,
            Disponibles: subTareasDisponibles,
            // Asume que deseas mantener listTwo como está, si no, ajusta según sea necesario
            Seleccionadas: item.subTareas
        }));
        setDragDisabled(false)
        setShowTask(true)
    }

    const openSubTask = (task, droppableId) => {
        if (droppableId != 'Seleccionadas') return;
        setShowTarea(task)
        setShowDescriptionTask(true)
    }

    const handleSaveTask = () => {
        const index = nomenclaturas.Seleccionadas.findIndex(item => item.id == showNomenclatura.id);

        if (index === -1) return;

        const nomenclaturasSeleccionadas = [...nomenclaturas.Seleccionadas];
        const nomenclaturaToUpdate = { ...nomenclaturasSeleccionadas[index], subTareas: subTareas.Seleccionadas };
        nomenclaturasSeleccionadas[index] = nomenclaturaToUpdate;
        // Actualiza el estado con la nueva lista
        setNomenclaturas(prevState => ({ ...prevState, Seleccionadas: nomenclaturasSeleccionadas }));
        setShowToast(true)
        setMessageToast("Tareas agregada a la Nomenclatura")
    }

    const saveTemplate = () => {
        if (idGrupo == null || idServicio == null) {
            alert("debe seleccionar grupo y servicio")
            return
        }

        var templateSave = template.data
        templateSave.listOfTasks = nomenclaturas.Seleccionadas.map((item, index) => {
            return {
                orden: index,
                nomencltureId: parseInt(item.id.replace('nomenclatura-', '')),
                nomenclatura: item.content,
                descripcion: '',
                subTareas: item.subTareas.map((task, ind) => {
                    var _idSubTask = parseInt(task.id.replace('task-', ''))
                    const objeto = subTasks.listSubTask.find(obj => obj.id === _idSubTask);
                    return {
                        orden: ind,
                        idSubTask: _idSubTask,
                        descripcion: task.Descripcion,
                        name: objeto ? objeto.name : 'No encontrado',//task.name,
                        acciones: task.acciones,
                        idUserCharge: task.idUserCharge ? task.idUserCharge : null
                    }
                })
            }
        })
        
        templateSave.type = "Workflow"
        templateSave.categoryId = "Workflow-Group-" + idGrupo
        templateSave.GroupId = idGrupo
        templateSave.ServiceId = idServicio
        //alert("enviando" + cosmosId)
        if (taskWorkflowId == null) {
            delete templateSave.id;
            dispatch(CreateTemplate(templateSave))
        } else {
            templateSave.Id = taskWorkflowId
            dispatch(UpdateTemplate(templateSave))
        }

        setShowToast(true)
        setMessageToast("Nomenclaturas y Tareas enviadas y almacendas")
    }


    useEffect(() => {
        if (templateCreado.status == 4) {
            /*
            ya se creo el template y ahora tengo que devolverlo a la lista de validacion pero solo el Id
            
            xxxxxxxxxxxxx
            */
            onclickWorkflowCreado({
                cosmosId: templateCreado.data.id,
                GroupId: templateCreado.data.groupId,
                ServiceId: templateCreado.data.serviceId, 
                causa: causa
            })
            setShowModal(false)

            dispatch(ClearTemplate())

            ////////////////
            setShow(false)
            setShowTask(false)
            setShowDescriptionTask(false)
            setShowAcctionTask(false)
            setShowDeleteAction({ showTarea: null, index: null, true: false })
            setShowToast(false)
            setShowSpinner(true)
            setMessageToast("")
            setSeleccionAction("")
            setAproved(false)
            setSearchNomenclature("")
            setsearchNomenclatureS("")
            setSearchTask("")
            setSearchTaskS("")
            setCosmosId(null)
            setNomenclaturas({ Disponibles: [], Seleccionadas: [] });
            setSubTareas({ Disponibles: [], Seleccionadas: [] });
            setShowNomenclatura({})
            setShowTarea({})
            setShowAcction({})
            setDragDisabled(true)
            setDocumentos([])
            setSelectDocumento([])
            setNomenclaturaAccion({})
            setServicioAccion({})
            setNomenclaturasAcciones([])
            setTareaAccion({})
            setTareasAcciones([])


            ///////////////////////////
        }
    }, [templateCreado])

    const onClicksetShowModal = () => {

        dispatch(ClearTemplate())


        ////////////////
        setShow(false)
        setShowTask(false)
        setShowDescriptionTask(false)
        setShowAcctionTask(false)
        setShowDeleteAction({ showTarea: null, index: null, true: false })
        setShowToast(false)
        setShowSpinner(true)
        setMessageToast("")
        setSeleccionAction("")
        setAproved(false)
        setSearchNomenclature("")
        setsearchNomenclatureS("")
        setSearchTask("")
        setSearchTaskS("")
        setCosmosId(null)
        setNomenclaturas({ Disponibles: [], Seleccionadas: [] });
        setSubTareas({ Disponibles: [], Seleccionadas: [] });
        setShowNomenclatura({})
        setShowTarea({})
        setShowAcction({})
        setDragDisabled(true)
        setDocumentos([])
        setSelectDocumento([])
        setNomenclaturaAccion({})
        setServicioAccion({})
        setNomenclaturasAcciones([])
        setTareaAccion({})
        setTareasAcciones([])


        setShowModal(false)
    }

    const addActionFromTask = (action, apruebo) => {
        if (seleccionAction == "") return;

        setSelectDocumento([])
        setServicioAccion({})

        setShowAcctionTask(true)
        setAproved(apruebo)
        setShowAcction(action)

    }

    const onSetSelectDocumento = (event) => {
        setSelectDocumento(event.value)
    }

    const onSetSelectNomenclaturasAcciones = (event) => {
        const objeto = nomenclaturas.Seleccionadas.find(item => item.id === event.value);
        setTareasAcciones(objeto.subTareas.map((item) => { return { value: item.id, label: item.name } }))
        setNomenclaturaAccion(objeto)
    }
    const onSetSelectServicio = (event) => {
        setServicioAccion(event)
    }

    const onSetSelectsubTareaAccion = (event) => {
        const objeto = nomenclaturaAccion.subTareas.find(item => item.id === event.value);
        setTareaAccion(objeto)
    }

    const handleDescripcionTaskChange = (e) => {
        // Actualiza solo la propiedad Descripcion de showTarea
        setShowTarea(prevState => ({
            ...prevState,
            Descripcion: e.target.value
        }))
    }

    const onChageSeleccionAction = (e) => {
        const objeto = listaAcciones.list.find(item => item.id == e.target.value);
        if (objeto)
            setSeleccionAction(objeto)
    }

    const setDeleteAction = () => {

        const indiceAEliminar = showDeleteAction.index
        setShowTarea(prevTask => {
            // Filtra la lista de acciones para eliminar el objeto en el índice dado
            const accionesActualizadas = prevTask.acciones.filter((_, index) => index !== indiceAEliminar);
            return {
                ...prevTask,
                acciones: accionesActualizadas
            };
        });

        setSubTareas(prevTask => {
            // Encuentra el índice del objeto en Sel que coincide con el ID
            const indice = prevTask.Seleccionadas.findIndex(objeto => objeto.id === showTarea.id);
            // Si no se encuentra el objeto, simplemente devuelve el estado anterior
            if (indice === -1) return prevTask;
            // Crea una copia de Sel y actualiza el objeto encontrado
            const SelActualizado = [...prevTask.Seleccionadas];
            //var acciones = SelActualizado[indice].acciones
            //acciones = acciones.push(data)
            const accionesActualizadas = SelActualizado[indice].acciones.filter((_, index) => index !== indiceAEliminar);

            SelActualizado[indice] = { ...SelActualizado[indice], acciones: accionesActualizadas };
            // Devuelve el nuevo estado con Sel actualizado
            return { ...prevTask, Seleccionadas: SelActualizado };
        });
        setShowDeleteAction({ showTarea: null, index: null, true: false })
    }

    const onSearchNomenclature = (value) => {

        setSearchNomenclature(value)

    }
    const onSearchNomenclatureS = (value) => { setsearchNomenclatureS(value) }
    const onSearchTask = (value) => { setSearchTask(value) }
    const onSearchTaskS = (value) => { setSearchTaskS(value) }

    const ShowUserCharge = (showTarea) => {
        var userSelect = showTarea.UserSelect
        if (userSelect==null && showTarea.idUserCharge) {
            try {
                var usersAux = usersCharge.data.find(user => user.id == showTarea.idUserCharge)
                var userLAux = usersLegal.data.find(user => user.id == usersAux.userId)
                userSelect.username = userLAux.nombre
                userSelect.branchOffice = usersAux.branchOffice.name
                userSelect.tribunal = usersAux.tribunal.name
                userSelect.charge = usersAux.charge.name
            } catch (e) {
            }
        }

        if (userSelect) 
            return (
                <table>
                    <tbody>
                        <tr>
                            <td>Usuario</td>
                            <td>{userSelect.username}</td>
                        </tr>
                        <tr>
                            <td>Sucursal</td>
                            <td>{userSelect.branchOffice}</td>
                        </tr>
                        <tr>
                            <td>Tribunal</td>
                            <td>{userSelect.tribunal}</td>
                        </tr>
                        <tr>
                            <td>Cargo</td>
                            <td>{userSelect.charge}</td>
                        </tr>
                    </tbody>
                </table>
            )
        
        return null;
    }

    return (
        <Fragment>
            <div className="container text-center mb-5">
                <div className="row">
                    <div className="col">
                        {showSpinner ? <h3><Spinner animation="grow" /> Buscando la plantilla seleccionda, espere...</h3> : null}
                    </div>
                    <Table>
                        <thead>
                            <tr>
                                <th>Rol</th>
                                <th>Tribunal</th>
                                <th>Caratulado</th>
                                <th>Demandante</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>C-3011-2024</td>
                                <td>3º Juzgado Civil De Antofagasta</td>
                                <td>Promotora Cmr Falabella  S.a./Portus</td>
                                <td>PROMOTORA CMR FALABELLA  S.A.</td>
                                <td><Button variant="primary" onClick={() => saveTemplate()}>Confirmar</Button></td>
                                <td><Button variant="secondary" onClick={() => onClicksetShowModal()}>Cerrar</Button></td>
                            </tr>
                        </tbody>
                    </Table>


                </div>
            </div>
            <div className='row' style={{ marginBottom: 70 }}>
                {/* NOMENCLATURAS*/}
                <DragDropContext onDragEnd={onDragEnd}>
                    {Object.entries(nomenclaturas).map(([droppableId, items], index) => (
                        <Droppable key={droppableId} droppableId={droppableId}>
                            {(provided) => (
                                <div className='col' ref={provided.innerRef} {...provided.droppableProps} style={{ margin: '0 8px', border: '1px solid lightgrey', padding: '8px', maxWidth: '48%' }} >
                                    <h2>{droppableId} {/*`Lista ${index + 1}`*/}</h2>
                                    {droppableId == 'Disponibles' ?
                                        <InputGroup className="mb-3">
                                            <Form.Control type="text" placeholder="Buscar Nomenclatura" value={searchNomenclature}
                                                onChange={(e) => onSearchNomenclature(e.target.value.toUpperCase())} />
                                            <Button variant="outline-secondary" id="button-addon2" onClick={() => setSearchNomenclature("")}> <Icon.Trash /> </Button>
                                        </InputGroup>
                                        :
                                        <InputGroup className="mb-3">
                                            <Form.Control type="text" placeholder="Buscar Nomenclatura" value={searchNomenclatureS}
                                                onChange={(e) => onSearchNomenclatureS(e.target.value.toUpperCase())} />
                                            <Button variant="outline-secondary" id="button-addon2" onClick={() => setsearchNomenclatureS("")}> <Icon.Trash /> </Button>
                                        </InputGroup>}

                                    {items.map((item, index) => (
                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                            {(provided) => (
                                                <>
                                                    {droppableId == 'Disponibles' ? // con filtro->onSearchNomenclature
                                                        <>{
                                                            searchNomenclature == '' || item.content.toUpperCase().includes(searchNomenclature) ?
                                                                <div
                                                                    className='shadow bg-white pb-2 pt-2'
                                                                    onClick={() => onShowSubTaskNom(item, droppableId)}
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={{ margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                                >
                                                                    {item.content}
                                                                </div>
                                                                :
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    hidden
                                                                > {item.content} no borrar div </div>
                                                        }</>
                                                        :
                                                        <>
                                                            {searchNomenclatureS != '' && item.content.toUpperCase().includes(searchNomenclatureS) ?
                                                                <div
                                                                    className='shadow bg-green pb-2 pt-2 text-white'
                                                                    onClick={() => onShowSubTaskNom(item, droppableId)}
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={{ backgroundColor: 'green', margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                                >
                                                                    {item.content}
                                                                </div> :
                                                                <div
                                                                    className='shadow bg-white pb-2 pt-2'
                                                                    onClick={() => onShowSubTaskNom(item, droppableId)}
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={{ margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                                >
                                                                    {item.content}
                                                                </div>

                                                            }</>

                                                    }
                                                </>



                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    ))}
                </DragDropContext>
            </div>

            {/* MODAL PARA SELECCIONAR LAS TAREAS PARA LA NOMENCLATURA */}
            <Modal show={showTask} onHide={handleCloseTask} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Tareas de la Nomenclatura <br /> {showNomenclatura.content}</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseTask}>cerrar</Button>
                    <Button variant="primary" onClick={handleSaveTask}>Guardar</Button>
                </Modal.Footer>
                <Modal.Body>
                    <div className='row'>
                        {/* TAREAS*/}
                        <DragDropContext onDragEnd={onDragEndSubTask} >
                            {Object.entries(subTareas).map(([droppableId, items], index) => (
                                <Droppable key={droppableId} droppableId={droppableId}>
                                    {(provided) => (
                                        <div className='col' ref={provided.innerRef} {...provided.droppableProps} style={{ margin: '0 8px', border: '1px solid lightgrey', padding: '8px' }} >
                                            <h2>{droppableId} {/*`Lista ${index + 1}`*/} {droppableId == 'Disponibles' ? <Button variant="outline-primary" onClick={handleShow}>+</Button> : null}</h2>

                                            {droppableId == 'Disponibles' ?
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Buscar Tarea" value={searchTask}
                                                        onChange={(e) => onSearchTask(e.target.value.toUpperCase())} />
                                                    <Button variant="outline-secondary" id="button-addon2"> <Icon.Search /> </Button>
                                                </InputGroup>
                                                :
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Buscar Tarea" value={searchTaskS}
                                                        onChange={(e) => onSearchTaskS(e.target.value.toUpperCase())} />
                                                    <Button variant="outline-secondary" id="button-addon2"> <Icon.Search /> </Button>
                                                </InputGroup>}

                                            {items.map((item, index) => (
                                                <Draggable key={item.id} draggableId={item.id} index={index} isDragDisabled={DragDisabled}>
                                                    {(provided) => (
                                                        <>
                                                            {droppableId == 'Disponibles' ? // con filtro->onSearchNomenclature
                                                                <>{
                                                                    searchTask == '' || item.Name.toUpperCase().includes(searchTask) ?
                                                                        <div
                                                                            className='shadow bg-white pb-2 pt-2'
                                                                            onClick={() => openSubTask(item, droppableId)}
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            style={{ margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                                        >
                                                                            {item.Name}
                                                                        </div>
                                                                        :
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            hidden
                                                                        >
                                                                            {item.Name} no quitar div
                                                                        </div>
                                                                }</>
                                                                :
                                                                <>
                                                                    {
                                                                        searchTaskS != '' && item.Name.toUpperCase().includes(searchTaskS) ?
                                                                            <div
                                                                                className='shadow bg-green pb-2 pt-2 text-white'
                                                                                onClick={() => openSubTask(item, droppableId)}
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                style={{ backgroundColor: 'green', margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                                            >
                                                                                {item.Name}
                                                                            </div> :
                                                                            <div
                                                                                className='shadow bg-white pb-2 pt-2'
                                                                                onClick={() => openSubTask(item, droppableId)}
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                style={{ margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                                            >
                                                                                {item.Name}
                                                                            </div>
                                                                    }</>

                                                            }
                                                            {/*
                                                        <div
                                                            className='shadow bg-white pb-2 pt-2'
                                                            onClick={() => openSubTask(item, droppableId)}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{ margin: '0 0 8px 0', paddingLeft: '8px', ...provided.draggableProps.style }}
                                                        >
                                                            {item.Name}
                                                        </div>
                                                        */}
                                                        </>

                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            ))}
                        </DragDropContext>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseTask}>cerrar</Button>
                    <Button variant="primary" onClick={handleSaveTask}>Guardar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL PARA AGREGAR TAREAS NUEVAS */}
            <Modal show={show} onHide={handleClose} style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
                <Modal.Header closeButton>
                    <Modal.Title>Nueva SubTarea</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onAddSubTask)}>
                    <Modal.Body>
                        <>
                            <Form.Label htmlFor="nameSubTask">Nombre</Form.Label>
                            <Form.Control type="text" id="nameSubTask" {...register("name")} />
                        </>
                        <div className='mt-2'>
                            <Form.Label htmlFor="descriptionSubTask">Descripción</Form.Label>
                            <Form.Control as="textarea" id="descriptionSubTask"  {...register("description")} />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>cerrar</Button>
                        <Button variant="primary" type='sumbit'>Guardar</Button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* MODAL PARA AGREGAR Informacion de la tarea */}
            <Modal show={showDescriptionTask} onHide={handleCloseDescriptionTask} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <Modal.Header closeButton>
                    <Modal.Title>Nomenclatura: {showNomenclatura.content} <br /> SubTarea: {showTarea.Name}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className='mt-2'>
                        <Form.Label htmlFor="descriptionSubTask">Descripción</Form.Label>
                        <Form.Control as="textarea" id="descriptionSubTask" value={showTarea.Descripcion} onChange={handleDescripcionTaskChange} />
                    </div>

                    <div className='mt-2'>
                        <Form.Label htmlFor="descriptionSubTask">Usuario <Button className='ms-3' onClick={() => setShowUserList(true)}>Asignar usuario</Button> </Form.Label>
                        {ShowUserCharge(showTarea)}
                    </div>

                    <div className='mt-2'>
                        <Form.Label htmlFor="descriptionSubTask">Lista De Acciones</Form.Label>
                        <ListGroup as="ul">
                            {showTarea.acciones && showTarea.acciones.length > 0 ? showTarea.acciones.map((item, index) => (
                                <ListGroup.Item onClick={() => setShowDeleteAction({ showTarea, index, true: true })} as="li" className="d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold"> {item.action.description}</div>
                                        <b>Tipo</b>: {item.action.name}
                                    </div>
                                    <Badge bg="info" className='me-2' pill>Limite: {item.dias} dias</Badge>
                                    <Badge bg={item.aprobar ? "success" : "danger"} pill>{item.aprobar ? "Al aprobar" : "Al rechazar"}</Badge>
                                </ListGroup.Item>
                            )) : <b className='m-3'>Sin Acciones asignadas</b>}
                        </ListGroup>
                    </div>

                    <div className='mt-2'>
                        <Form.Label>Agregar Acción</Form.Label>
                        <Form.Select onChange={onChageSeleccionAction} aria-label="Default select example" required>
                            <option value={-1}>Seleccione...</option>
                            {listaAcciones.list.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                            ))}
                        </Form.Select>
                    </div>
                    <div className='mt-2'>
                        <Button variant="info" onClick={() => addActionFromTask(seleccionAction, true)}>Accion para Aprobar</Button>
                        <Button variant="secondary" onClick={() => addActionFromTask(seleccionAction, false)}>Accion para Rechazar</Button>
                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleCloseDescriptionTask()}>cerrar</Button>
                    <Button variant="primary" type='sumbit' onClick={() => handleSaveDescriptionTask()} >Guardar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL PARA AGREGAR Y CONFIGURAR LAS ACCIONES*/}
            <Modal show={showAcctionTask} onHide={handleCloseAcctionTask} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
                <Modal.Header closeButton>
                    <Modal.Title>Configurar Accion</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmitC(onAddAcctionTask)}>
                    <Modal.Body>
                        <h5>{showAcction.name}</h5>

                        <div className='mt-3 mb-3'>
                            <Form.Label htmlFor="dias">Dias para fecha limite <b>PARA LA SIGUIENTE TAREA</b> </Form.Label>
                            <Form.Control /*as="textarea"*/ type="number" id="dias"  {...registerC("dias")} />
                        </div>
                        {showAcction.id != 4 ? <>
                            {showAcction.id == 1 ?
                                <div className='mt-2'>
                                    <Form.Label htmlFor="documento">Documento</Form.Label>
                                    <Select {...registerC("documento")}
                                        onChange={(e) => onSetSelectDocumento(e)}
                                        options={documentos}
                                        className="basic-single mb-4"
                                        classNamePrefix="select"
                                        //defaultValue={colourOptions[0]}
                                        //isDisabled={false}
                                        //isLoading={searchServicio}
                                        isClearable={true}
                                        isRtl={false}
                                        isSearchable={true}
                                        //name="color"
                                    />
                                </div>
                                : null}
                            {showAcction.id == 2 ?
                                <>
                                    <div className='mt-2'>
                                        <Form.Label htmlFor="nomenclatura">Nomenclatura</Form.Label>
                                        <Select
                                            {...registerC("nomenclatura")}
                                            onChange={(e) => onSetSelectNomenclaturasAcciones(e)}
                                            options={nomenclaturasAcciones}
                                            className="basic-single mb-4"
                                            classNamePrefix="select"
                                            //defaultValue={colourOptions[0]}
                                            //isDisabled={false}
                                            //isLoading={searchServicio}
                                            isClearable={true}
                                            isRtl={false}
                                            isSearchable={true}
                                        //name="color"
                                        />
                                    </div>
                                    <div className='mt-2'>
                                        <Form.Label htmlFor="subTarea">subTarea</Form.Label>
                                        <Select
                                            {...registerC("subTarea")}
                                            onChange={(e) => onSetSelectsubTareaAccion(e)}
                                            options={tareasAcciones}
                                            className="basic-single mb-4"
                                            classNamePrefix="select"
                                            //defaultValue={colourOptions[0]}
                                            //isDisabled={false}
                                            //isLoading={searchServicio}
                                            isClearable={true}
                                            isRtl={false}
                                            isSearchable={true}
                                        //name="color"
                                        />
                                    </div>
                                </>
                                : null}

                            {showAcction.id == 3 ?
                                <>
                                    <div className='mt-2'>
                                        <Form.Label htmlFor="nomenclatura">Servicio</Form.Label>
                                        <Select
                                            {...registerC("servicio")}
                                            onChange={(e) => onSetSelectServicio(e)}
                                            options={servicios}
                                            className="basic-single mb-4"
                                            classNamePrefix="select"
                                            //defaultValue={colourOptions[0]}
                                            //isDisabled={false}
                                            //isLoading={searchServicio}
                                            isClearable={true}
                                            isRtl={false}
                                            isSearchable={true}
                                        //name="color"
                                        />
                                    </div>
                                </>
                                : null}
                        </> : null
                        }

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => handleCloseAcctionTask()}>cerrar</Button>
                        <Button variant="primary" type='sumbit'>Guardar</Button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* MODAL PARA AGREGAR Informacion de la tarea */}
            <Modal show={showDeleteAction.true} onHide={() => setShowDeleteAction({ showTarea: null, index: null, true: false })} style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
                <Modal.Header closeButton>
                    <Modal.Title>Desea Eliminar La Acción?</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteAction({ showTarea: null, index: null, true: false })}>Volver</Button>
                    <Button variant="warning" type='button' onClick={() => setDeleteAction()}>Eliminar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL PARA AGREGAR usuarios a la tarea */}
            <Modal show={showUSerList} onHide={handleCloseUserListTask} size='lg' style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <Modal.Header closeButton>
                    <Modal.Title>Nomenclatura: {showNomenclatura.content} <br /> SubTarea: {showTarea.Name}</Modal.Title>
                    <Table striped bordered hover>
                        <tbody>
                            <tr>
                                <td>Usuario</td>
                                <td>{UserSelect ? UserSelect.username : ''}</td>
                            </tr>
                            <tr>
                                <td>Sucursal</td>
                                <td>{UserSelect ? UserSelect.branchOffice : ''}</td>
                            </tr>
                            <tr>
                                <td>Tribunal</td>
                                <td>{UserSelect ? UserSelect.tribunal : ''}</td>
                            </tr>
                            <tr>
                                <td>Cargo</td>
                                <td>{UserSelect ? UserSelect.charge : ''}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Header>
                <Modal.Body>
                    <div className='mt-2'>
                        <BootstrapTable keyField='id'
                            data={UsuariosTareas}
                            columns={columns}
                            filter={filterFactory()}
                            pagination={paginationFactory()}
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleCloseUserListTask()}>cerrar</Button>
                    <Button variant="primary" type='sumbit' onClick={() => handleSaveUserTask()} >Guardar</Button>
                </Modal.Footer>
            </Modal>

            <Toast show={showToast} onClose={(e) => setShowToast(false)} bg="info" className='position-fixed top-0 end-0 mt-3 me-3' style={{ zIndex: "10000" }} delay={3000} autohide>
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded me-2"
                        alt=""
                    />
                    <strong className="me-auto">Atencion!</strong>
                </Toast.Header>
                <Toast.Body className='text-white'>
                    {messageToast}
                </Toast.Body>
            </Toast>
        </Fragment>
    );
};

export default NomenclaturasB;
